<template>
  <div class="page-wrapper">
    <AppHeader title="Product Management" />
    <div class="container" style="width: 95% !important">
    <div class="container left w-100">
      <div class="row topnav" >
        <!-- <div class="col-sm-1">
          <div
            class="dropdown"
            style="
              position: fixed;
              left: 0;
              top: 0;
              padding: 0;
              margin-top: 0;
              margin-bottom: 0;
            "
          >
            <MainMenu />
          </div>
        </div> -->
<div class="col-sm-12" style="display: flex; align-items: center; gap: 30px; margin-bottom: 20px;">

  <!-- Input -->
  <div class="input-group touch-search-group" style="flex: 1; max-width: 520px;">
    <span class="input-group-addon">
      <i class="glyphicon glyphicon-barcode"></i>
    </span>
    <input
      type="text"
      ref="order_id"
      v-on:keyup.enter="getProduct(product_id)"
      v-model="product_id"
      id="order_id"
      name="order_id"
      class="form-control input-lg"
      placeholder="Enter Product Barcode/Item Code"
    />
    <span class="input-group-btn">
      <button class="btn btn-success btn-lg" @click="getProduct(product_id)">
        Search
      </button>
    </span>
  </div>

  <!-- URA Synced -->
  <div
    style="
      display: flex;
      align-items: center;
      gap: 12px;
      color: #ffffff;
      margin-left: auto;
    "
  >
    <!-- <label title="ura_synced" style="font-size: 1.2em; margin: 0;">
      URA Synced
    </label> -->

    <div class="checkbox-grid ura-synced-grid" style="margin: 0;">
      <div
        class="permission-card"
        :class="{ active: is_ura_synced === 1 }"
        @click="setIsUraSynced(1)"
      >
        <div class="custom-checkbox">
          <i class="fa fa-check checkmark"></i>
        </div>
        <span>Synced</span>
      </div>
      <!-- Search result now renders inside table; modal removed -->

      <div
        class="permission-card"
        :class="{ active: is_ura_synced === 0 }"
        @click="setIsUraSynced(0)"
      >
        <div class="custom-checkbox">
          <i class="fa fa-check checkmark"></i>
        </div>
        <span>Unsynced</span>
      </div>
    </div>
  </div>

  <!-- Error -->
  <div v-show="showError" style="text-align: center; flex-basis: 100%;">
    <label class="h3" style="color: maroon">
      {{ this.mainErrorMsg }}
    </label>
  </div>

</div>
      </div>

      <div v-if="showAddPromotion" class="w-100 no-scrollbar" style="overflow-y: auto; max-height: 80vh; padding: 10px; display: flex; justify-content: center;">
        <div class="card shadow-lg" style="background-color: var(--form-color); padding: 30px; border-radius: 15px; max-width: 1000px; color: var(--theme-text-main);">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-6 mb-3" style="margin-bottom: 15px;">
                <div class="form-group">
                  <label style="font-size: 1.2em; display: block; margin-bottom: 5px;">Item Name</label>
                  <input disabled type="text" v-model="product.item_name" class="form-control input-lg" 
                    style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);" />
                </div>
              </div>

              <div class="col-md-6 mb-3" style="margin-bottom: 15px;">
                <div class="form-group">
                  <label style="font-size: 1.2em; display: block; margin-bottom: 5px;">EFRIS Item Name</label>
                  <input disabled type="text" v-model="product.efris_item_name" class="form-control input-lg" 
                    style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);" />
                </div>
              </div>

              <div class="col-md-6 mb-3" style="margin-bottom: 15px;">
                <div class="form-group">
                  <label style="font-size: 1.2em; display: block; margin-bottom: 5px;">Item Code</label>
                  <input type="text" disabled v-model="product.item_code" class="form-control input-lg" 
                    style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);" />
                </div>
              </div>

              <div class="col-md-6 mb-3" style="margin-bottom: 15px;">
                <div class="form-group">
                  <label style="font-size: 1.2em; display: block; margin-bottom: 5px;">EFRIS Item Code</label>
                  <input disabled type="text" v-model="product.efris_item_code" class="form-control input-lg" 
                    style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);" />
                </div>
              </div>

              <div class="col-md-6 mb-3" style="margin-bottom: 15px;">
                <div class="form-group">
                  <label style="font-size: 1.2em; display: block; margin-bottom: 5px;">Barcode</label>
                  <input type="text" v-model="product.barcode" class="form-control input-lg" 
                    style="font-size: 1.2em; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); color: var(--theme-text-main);" />
                </div>
              </div>

              <div class="col-md-6 mb-3" style="margin-bottom: 15px;">
                <div class="form-group">
                  <label style="font-size: 1.2em; display: block; margin-bottom: 5px;">URA Commodity Category</label>
                  <input disabled type="text" v-model="product.ura_commodity_category" class="form-control input-lg" 
                    style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);" />
                </div>
              </div>

              <div class="col-md-6 mb-3" style="margin-bottom: 15px;">
                <div class="form-group">
                  <label style="font-size: 1.2em; display: block; margin-bottom: 5px;">UOM</label>
                  <input disabled type="text" v-model="product.uom" class="form-control input-lg" 
                    style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);" />
                </div>
              </div>

              <div class="col-md-6 mb-3" style="margin-bottom: 15px;">
                <div class="form-group">
                  <label style="font-size: 1.2em; display: block; margin-bottom: 5px;">Standard Rate</label>
                  <input disabled type="text" v-model="product.standard_rate" class="form-control input-lg" 
                    style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);" />
                </div>
              </div>

              <div class="col-md-12 mb-3" style="margin-bottom: 15px;">
                <div class="form-group">
                  <label style="font-size: 1.2em; display: block; margin-bottom: 10px;">URA Synced</label>
                  <div class="checkbox-grid ura-synced-grid">
                    <div
                      class="permission-card"
                      :class="{ active: product.ura_synced === 1 }"
                      @click="product.ura_synced = 1"
                    >
                      <div class="custom-checkbox">
                        <i class="fa fa-check checkmark"></i>
                      </div>
                      <span>Synced</span>
                    </div>

                    <div
                      class="permission-card"
                      :class="{ active: product.ura_synced === 0 }"
                      @click="product.ura_synced = 0"
                    >
                      <div class="custom-checkbox">
                        <i class="fa fa-check checkmark"></i>
                      </div>
                      <span>Unsynced</span>
                    </div>
                  </div>
                </div>
              </div>
                <div class="row" style="margin-top: 20px; padding-top: 20px;">
                  <div class="col-12" style="text-align: right;">
                    <button class="btn btn-danger btn-lg" style="font-size: 1.2em; margin-right: 10px;" @click="cancelSavePromotion">Back</button>
                    <button class="btn btn-success btn-lg" v-if="productId === -1" style="font-size: 1.2em;" @click="createProduct">Save</button>
                    <button class="btn btn-success btn-lg" v-if="productId !== -1" style="font-size: 1.2em;" @click="updateProduct">Update</button>
                  </div>
              </div>
            </div>



            <!-- <div v-if="product.ura_synced == 0 || product.ura_synced == false" class="row" style="margin-top: 20px;">
              <div class="col-12">
                <div class="alert alert-danger" style="background: rgba(255,0,0,0.1); border: 1px solid rgba(255,0,0,0.2); color: #ff6b6b;">
                  <h3 style="margin-top: 0;">URA Sync Error</h3>
                  <textarea rows="5" style="width: 100%; font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);" v-model="efris_error" disabled class="form-control"></textarea>
                  <div style="margin-top: 10px; text-align: right;">
                     <button class="btn btn-success" style="font-size: 1.2em;" @click="syncProduct">Sync Now</button>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>


      <div v-if="toggle && !loading">
        <div
          v-if="toggle"
          class="row table-wrap"
          style="color: #fff; "
        >
          <table class="table" style="color: #fff">
            <thead>
              <tr>
                <th style="font-size: 1.2em">Item Name</th>
                <th style="font-size: 1.2em">Efris Name</th>
                <th style="font-size: 1.2em">Item Code</th>
                <th style="font-size: 1.2em">Efris Code</th>
                <th style="font-size: 1.2em">Barcode</th>
                <th style="font-size: 1.2em">URA Commodity Category</th>
                <th style="font-size: 1.2em">UOM</th>
                <th style="font-size: 1.2em">Standard Rate</th>
                <th style="font-size: 1.2em">Sync Status</th>
                <th style="font-size: 1.2em">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="product in allProducts" :key="product.id">
                <td style="font-size: 1.2em">{{ product.item_name }}</td>
                <td style="font-size: 1.2em">{{ product.efris_item_name }}</td>
                <td style="font-size: 1.2em">{{ product.item_code }}</td>
                <td style="font-size: 1.2em">{{ product.efris_item_code }}</td>
                <td style="font-size: 1.2em">{{ product.barcode }}</td>
                <td style="font-size: 1.2em">
                  {{ product.ura_commodity_category }}
                </td>
                <td style="font-size: 1.2em">{{ product.uom }}</td>
                <td style="font-size: 1.2em">{{ product.standard_rate }}</td>
                <td style="font-size: 1.2em">
                  {{ product.ura_synced == 1 ? "✔️" : "❌" }}
                </td>
                <td>
                  <button
                    v-if="hasPermission(50)"
                    class="btn btn-success"
                    style="font-size: 1.2em"
                    @click="editProduct(product)"
                  >
                    Edit
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <ul class="pagination">
            <li class="page-item" :class="{ disabled: page === 1 }">
              <a class="page-link" href="#" @click="goToPage(page - 1)"
                >Previous</a
              >
            </li>

            <li v-if="page > 3">
              <a class="page-link" href="#" @click="goToPage(1)">1</a>
            </li>

            <li v-if="page > 4">
              <span class="page-link">...</span>
            </li>

            <li
              v-for="pageNumber in visiblePages"
              :key="pageNumber"
              :class="{ active: page === pageNumber }"
            >
              <a class="page-link" href="#" @click="goToPage(pageNumber)">{{
                pageNumber
              }}</a>
            </li>

            <li v-if="page < totalPages - 3">
              <span class="page-link">...</span>
            </li>

            <li v-if="page < totalPages - 2">
              <a class="page-link" href="#" @click="goToPage(totalPages)">{{
                totalPages
              }}</a>
            </li>

            <li class="page-item" :class="{ disabled: page === totalPages }">
              <a class="page-link" href="#" @click="goToPage(page + 1)">Next</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from "axios";
import commonServices from "@/shared/commonServices";
import AppHeader from "@/components/AppHeader";
import MainMenu from "@/components/MainMenu";
import Datepicker from "vuejs3-datepicker";
import "vue-date-pick/dist/vueDatePick.css";
import Void from "@/components/Void";
import { mapGetters } from "vuex";
export default {
  components: { MainMenu, Void, Datepicker, AppHeader },
  computed: {
    totalPages() {
      if (this.totalLength) {
        return Math.ceil(this.totalLength / 15);
      }
      return 0;
    },
    visiblePages() {
      let startPage = Math.max(1, this.page - 2);
      let endPage = Math.min(this.totalPages, startPage + 4);

      if (endPage - startPage < 4) {
        startPage = Math.max(1, endPage - 4);
      }

      return Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
      );
    },
    ...mapGetters({
      posData: "posData",
      modules: "modules_options/modulesPers",
      productPermissions: "modules_options/productPermissions",
    }),
  },
  mixins: [commonServices],
  mounted() {
    //   this.getActivePromotions();
    this.getAllProducts();
    if (localStorage.userId !== undefined && localStorage.appId !== undefined) {
    } else {
      this.$router.push({ name: "login" });
    }
    this.language = "ar";
    this.handleLanguage();
    //this.getLogo();
    this.logoImage =
      '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';
  },
  data: function () {
    return {
      page: 1,
      efris_error: "",
      loading: false,
      searchResult: null,
      product: {
        item_name: "",
        efris_item_name: "",
        item_code: "",
        efris_item_code: "",
        barcode: "",
        ura_commodity_category: "",
        uom: "",
        standard_rate: "",
        ura_synced: 1,
      },
      modulePermissions: [],
      state: { start_date: new Date(2016, 9, 16) },
      stateEnd: { end_date: new Date(2016, 9, 16) },
      showAddPromotion: false,
      totalLength: 0,
      showDuplicatePromotion: false,
      showPermissions: false,
      promotions: [],
      allProducts: [],
      product_id: "",
      productJson: {},
      promotionJson: {},
      promotionInfos: {},
      productId: -1,
      is_ura_synced: 0,
      promoition_name: "",
      start_date: "",
      end_date: "",
      minimum_total: "",
      percentage: "",
      name: "",
      authorizedToChangePrice: "N",
      isVoidOpen: false,
      ip: "",
      repeat_ip: "",
      reports_ok: false,
      showError: false,
      logoImage: "",
      mainErrorMsg: "",
      logoUrl: "",
      jsonData: {},
      language: "en",
      languageName: "",
      toggle: true,
      showInvoices: false,
      showPayments: false,
      addresses: [],
      selectedcustomers: [],
      customer_invoices: [],
      customer_payments: [],
      customersJson: {},
      name: "",
      gender: "",
      email: "",
      phone: "",
      totalpoints: "",
      dis_percentage: "",
      status: "",
      creditstatus: "",
      date_added: "",
      aaddressid: 0,
      addressLine1: "",
      addressLine2: "",
      addressArea: "",
      addressCity: "",
      isDefault: false,
      customerAddresses: [],
      showAddress: false,
      findcustomer: "",
      findcustomername: "",
      customeraddress: {},
      productPerms: [],
    };
  },
  methods: {
    setIsUraSynced(value) {
      this.is_ura_synced = value;
      this.getAllProducts();
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.page = page;
        this.getAllProducts();
      }
    },

    getProduct: async function (barcodeVar) {
      if (barcodeVar !== "") {
        try {
          //let dataURL = this.apiURL+'Products/findProduct?appId=7&barcode='+barcodeVar;

          let dataURL =
            this.apiURL +
            "Products/findProductManagement?appId=7&product_id=" +
            barcodeVar;

          let response = await axios.post(dataURL, {
            appId: localStorage.appId,
            product_id: barcodeVar,
            offset: (this.page - 1) * 15,
          });

          if (response.data.status === "success") {
            const results = response.data.results;
            if (Array.isArray(results)) {
              const row = this.normalizeProductRow(results[0] || {});
              this.allProducts = [row];
              this.totalLength = 1;
              this.searchResult = null;
              return;
            }
            if (results && results.products && results.products.length === 1) {
              this.allProducts = results.products;
              this.totalLength = response.data.total_length;
              this.searchResult = null;
            } else {
              let suffixL = this.posData.suffix_length;

              barcodeVar = barcodeVar.substring(0, barcodeVar.length - suffixL);

              let newBacode = "";

              let newBacodeType = "";

              let barcodeDefLength = parseInt(
                this.posData.scale_barcode_length
              );

              let prefixQ = this.posData.prefix_barcode_qty.length;

              if (prefixQ > 0) {
                newBacodeType = barcodeVar.substring(0, prefixQ);

                newBacode = barcodeVar.substring(
                  prefixQ,
                  barcodeDefLength + prefixQ
                );

                if (newBacodeType === this.posData.prefix_barcode_qty) {
                  dataURL =
                    this.apiURL +
                    "Products/findProductManagement?appId=7&product_id=" +
                    newBacode;

                  response = await axios.post(dataURL, {
                    appId: localStorage.appId,
                    product_id: newBacode,
                    offset: (this.page - 1) * 15,
                  });

                  const res2 = response.data.results;
                  if (Array.isArray(res2)) {
                    const row2 = this.normalizeProductRow(res2[0] || {});
                    this.allProducts = [row2];
                    this.totalLength = 1;
                    this.searchResult = null;
                  } else {
                    this.allProducts = res2.products || [];
                    this.totalLength = response.data.total_length || 0;
                    this.searchResult = null;
                  }

                  return;
                }
              }

              let prefixP = this.posData.prefix_barcode_prc.length;

              newBacodeType = barcodeVar.substring(0, prefixP);

              newBacode = barcodeVar.substring(
                prefixP,
                barcodeDefLength + prefixP
              );

              if (newBacodeType === this.posData.prefix_barcode_prc) {
                dataURL =
                  this.apiURL +
                  "Products/findProductManagement?appId=7&product_id=" +
                  newBacode;

                response = await axios.post(dataURL, {
                  appId: localStorage.appId,
                  product_id: newBacode,
                  offset: (this.page - 1) * 15,
                });

                const res3 = response.data.results;
                if (Array.isArray(res3)) {
                  const row3 = this.normalizeProductRow(res3[0] || {});
                  this.allProducts = [row3];
                  this.totalLength = 1;
                  this.searchResult = null;
                } else {
                  this.allProducts = res3.products || [];
                  this.totalLength = response.data.total_length || 0;
                  this.searchResult = null;
                }

                return;
              } else {
                if (results && typeof results === "object" && !results.products) {
                  const row4 = this.normalizeProductRow(results || {});
                  this.allProducts = [row4];
                  this.totalLength = 1;
                  this.searchResult = null;
                  return;
                }
                this.showAlert("Item not found please try again");
              }
            }
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        this.searchResult = null;
        this.getAllProducts();
      }
    },
    normalizeProductRow(obj) {
      return {
        id: obj.id ?? 0,
        item_name: obj.itemName ?? obj.item_name ?? "",
        efris_item_name: obj.efris_item_name ?? (obj.itemName ?? ""),
        item_code: obj.itemCode ?? obj.item_code ?? "",
        efris_item_code: obj.efris_item_code ?? "",
        barcode: obj.barcode ?? "",
        ura_commodity_category: obj.categoryName ?? obj.ura_commodity_category ?? "",
        uom: obj.uom ?? "",
        standard_rate: obj.standardRate ?? obj.standard_rate ?? "",
        ura_synced: obj.ura_synced ?? 0,
      };
    },

    editProduct(product) {
      console.log(product);
      this.product = product;

      this.productId = product.id;
      this.toggle = false;
      this.showAddPromotion = true;
    },

    createProduct: async function () {
      if (this.ip == "" || this.name == "") {
        this.showAlert("Please Fill All fields!");
        return;
      }
      this.productJson.appId = localStorage.appId;
      this.productJson.name = this.name;
      this.productJson.ip = this.ip;
      try {
        let dataURL = this.apiURL + "ProductManagement/createProduct";
        let response = await axios.post(dataURL, this.productJson);
        if (response.data.status === "success") {
          this.showSuccess("Product Added Successfully!");
          this.getAllProducts();
          this.handleAddProduct();
        } else {
          this.showAlert("Error Happened Please Check Entered Data!");
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancelSavePromotion() {
      (this.product = {
        item_name: "",
        efris_item_name: "",
        item_code: "",
        efris_item_code: "",
        barcode: "",
        ura_commodity_category: "",
        uom: "",
        standard_rate: "",
        ura_synced: 1,
      }),
        (this.toggle = true);
      this.showAddPromotion = false;
      this.showPermissions = false;
      this.showDuplicatePromotion = false;
    },

    syncProduct: async function () {
      try {
        this.showInfo("Processing Product With URA");
        let uraJson = {
          username: localStorage.username,
          barcode: this.product.barcode,
        };
        let dataURL = this.apiURL + "SendToEfris/syncProduct";
        let response = await axios.post(dataURL, uraJson);
        if (response.data.status === "success") {
          this.allProducts[
            this.allProducts.findIndex(
              (el) => el.item_code == this.product.item_code
            )
          ] = this.product;
          this.showSuccess("Synced To URA");
        } else {
          this.efris_error = response.data.errorMsg;
          this.showAlert("Error Syncing With URA");
        }
      } catch (err) {
        this.showAlert("Error Syncing With URA");
      }
    },
    updateProduct: async function () {
      const requiredFields = [
        "item_name",
        "efris_item_name",
        "item_code",
        "efris_item_code",
        "barcode",
        "ura_commodity_category",
        "uom",
        "standard_rate",
        "ura_synced",
      ];
      if (
        requiredFields.filter(
          (key) =>
            this.product[key] === "" ||
            this.product[key] === null ||
            this.product[key] === undefined
        ).length > 0
      ) {
        this.showAlert("Please Fill All fields!");
        return;
      }
      this.productJson.appId = localStorage.appId;
      this.productJson = this.product;
      this.productJson.id = this.productId;

      try {
        let dataURL = this.apiURL + "ProductManagement/updateProduct";
        let response = await axios.post(dataURL, this.productJson);
        if (response.data.status === "success") {
          this.showSuccess("Product Updated Successfully!");
          this.allProducts[
            this.allProducts.findIndex(
              (el) => el.item_code == this.product.item_code
            )
          ] = this.product;
          // this.getAllProducts();
           this.cancelSavePromotion();
        } else {
          this.showAlert("Error Happened Please Check Entered Data!");
        }
      } catch (error) {
        console.log(error);
      }
    },

    handleAddProduct: async function () {
      this.showAddPromotion = true;
      this.productId = -1;
      this.name = "";
      this.ip = "";
      this.ura = "";
      this.repeat_ip = "";
      this.showError = false;
      this.mainErrorMsg = "";
      this.showAddCustomer = true;
      this.toggle = false;
    },
    getAllProducts: async function () {
      this.productJson.appId = localStorage.appId;
      this.productJson.is_ura_synced = this.is_ura_synced;
      this.productJson.offset = (this.page - 1) * 15;
      this.loading = true;
      try {
        let dataURL = this.apiURL + "ProductManagement/getAllProducts";
        let response = await axios.post(dataURL, this.productJson);
        if (response.data.status === "success") {
          this.allProducts = response.data.results;
          this.totalLength = response.data.total_length;
          this.loading = false;
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
      return this.allProducts;
    },
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 20px;
}

.glyphicon.glyphicon-ok {
  font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #eeeeee;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #cccccc;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #cccccc; */
}

.grid-container-element {
  display: grid;
  grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr;
  grid-gap: 10px;
  border: 1px solid whitesmoke;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  width: 100%;
}

.grid-child-element_ {
  margin: 10px;
  border: 1px solid red;
}

.grid-child-element {
  margin: 2px;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  padding: 0 px;
}

.check-label {
  color: #fff;
  font-size: 1.5rem;
  margin-left: 1rem;
  margin: 1rem 0;
}

.w-100 {
  width: 100%;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.ura-synced-grid {
  max-width: 520px;
}

.permission-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1rem;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
}

.permission-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

.permission-card.active {
  background: rgba(92, 107, 192, 0.2);
  border-color: var(--theme-primary);
  box-shadow: 0 4px 12px rgba(92, 107, 192, 0.15);
}

.custom-checkbox {
  width: 24px;
  height: 24px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: rgba(0,0,0,0.1);
  flex-shrink: 0;
}

.permission-card.active .custom-checkbox {
  background: var(--theme-primary);
  border-color: var(--theme-primary);
  transform: scale(1.05);
}

.checkmark {
  font-size: 14px;
  color: white;
  opacity: 0;
  transform: scale(0.5);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.permission-card.active .checkmark {
  opacity: 1;
  transform: scale(1);
}

.permission-card span {
  color: white;
  font-size: 1.2rem;
}

.pm-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.pm-modal-card {
  width: 80%;
  max-width: 900px;
  background-color: var(--form-color);
  color: var(--theme-text-main);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  padding: 16px;
}

.pm-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.pm-modal-title {
  font-size: 1.4rem;
  font-weight: 700;
}

.pm-label {
  font-weight: 700;
}

.pm-value {
  margin-top: 4px;
}

.pagination {
  justify-content: center;
  gap: 6px;
}

.pagination .page-item {
  list-style: none;
}

.pagination .page-link {
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.08);
  color: #ffffff;
  border-radius: 8px;
  padding: 6px 12px;
  min-width: 40px;
  margin: 2px;
  text-align: center;
  transition: all 0.2s ease;
}

/* Hover */
.pagination .page-link:hover {
  background: var(--form-color);
  border-color: var(--theme-primary);
  color: #ffffff;
  transform: translateY(-2px);
}

/* Active Page */
.pagination .active .page-link {
  background: linear-gradient(135deg, var(--theme-primary), var(--theme-secondary));
  border-color: var( --theme-accent);
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 4px 12px var(--theme-bg-end);
}

/* Disabled */
.pagination .disabled .page-link {
  opacity: 0.4;
  pointer-events: none;
}

/* Remove underline */
.pagination .page-link {
  text-decoration: none;
}
</style>
